// extracted by mini-css-extract-plugin
export var header = "_xf-1";
export var maskBottom = "_xf-6";
export var maskMiddle = "_xf-7";
export var maskTop = "_xf-5";
export var root = "_xf-0";
export var scrollDownButton = "_xf-3";
export var scrollDownButtonHidden = "_xf-4";
export var viewport = "_xf-2";